"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-monitor/testing/credit-monitor-testing-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-monitor%2Ftesting%2Fcredit-monitor-testing-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetMigrationContext = exports.UpdateUserResponse = exports.UpdateUserRequest = exports.SetMockCreditStateResponse = exports.SetMockCreditStateRequest = void 0;
const migration_1 = require("../migration");
const mock_credit_pull_response_1 = require("./mock-credit-pull-response");
const protobufPackage = 'com.step.creditmonitor.testing.proto';
function createBaseSetMockCreditStateRequest() {
    return { userId: '', mockResponse: mock_credit_pull_response_1.MockCreditPullResponse.fromPartial({}) };
}
exports.SetMockCreditStateRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            mockResponse: isSet(object.mockResponse)
                ? mock_credit_pull_response_1.MockCreditPullResponse.fromJSON(object.mockResponse)
                : mock_credit_pull_response_1.MockCreditPullResponse.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.mockResponse !== undefined) {
            obj.mockResponse = mock_credit_pull_response_1.MockCreditPullResponse.toJSON(message.mockResponse);
        }
        return obj;
    },
    create(base) {
        return exports.SetMockCreditStateRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetMockCreditStateRequest();
        message.userId = object.userId ?? '';
        message.mockResponse = (object.mockResponse !== undefined && object.mockResponse !== null)
            ? mock_credit_pull_response_1.MockCreditPullResponse.fromPartial(object.mockResponse)
            : mock_credit_pull_response_1.MockCreditPullResponse.fromPartial({});
        return message;
    },
};
function createBaseSetMockCreditStateResponse() {
    return {};
}
exports.SetMockCreditStateResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetMockCreditStateResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetMockCreditStateResponse();
        return message;
    },
};
function createBaseUpdateUserRequest() {
    return { userId: '', migrationContext: undefined };
}
exports.UpdateUserRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        if (isSet(object.migrationContext)) {
            message.migrationContext = exports.SetMigrationContext.fromJSON(object.migrationContext);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.migrationContext !== undefined) {
            obj.migrationContext = exports.SetMigrationContext.toJSON(message.migrationContext);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateUserRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateUserRequest();
        message.userId = object.userId ?? '';
        message.migrationContext =
            (object.migrationContext !== undefined && object.migrationContext !== null)
                ? exports.SetMigrationContext.fromPartial(object.migrationContext)
                : undefined;
        return message;
    },
};
function createBaseUpdateUserResponse() {
    return {};
}
exports.UpdateUserResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UpdateUserResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUpdateUserResponse();
        return message;
    },
};
function createBaseSetMigrationContext() {
    return {
        isLegacyMigrated: false,
        migrationImpact: migration_1.MigrationImpact.INVALID_MIGRATION_IMPACT,
        hasLegacyScore: false,
    };
}
exports.SetMigrationContext = {
    fromJSON(object) {
        const message = {
            isLegacyMigrated: isSet(object.isLegacyMigrated)
                ? globalThis.Boolean(object.isLegacyMigrated)
                : false,
        };
        if (isSet(object.migrationImpact)) {
            message.migrationImpact = (0, migration_1.migrationImpactFromJSON)(object.migrationImpact);
        }
        if (isSet(object.hasLegacyScore)) {
            message.hasLegacyScore = globalThis.Boolean(object.hasLegacyScore);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isLegacyMigrated !== false) {
            obj.isLegacyMigrated = message.isLegacyMigrated;
        }
        if (message.migrationImpact !== undefined &&
            message.migrationImpact !== migration_1.MigrationImpact.INVALID_MIGRATION_IMPACT) {
            obj.migrationImpact = (0, migration_1.migrationImpactToJSON)(message.migrationImpact);
        }
        if (message.hasLegacyScore !== undefined && message.hasLegacyScore !== false) {
            obj.hasLegacyScore = message.hasLegacyScore;
        }
        return obj;
    },
    create(base) {
        return exports.SetMigrationContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetMigrationContext();
        message.isLegacyMigrated = object.isLegacyMigrated ?? false;
        message.migrationImpact = object.migrationImpact ?? migration_1.MigrationImpact.INVALID_MIGRATION_IMPACT;
        message.hasLegacyScore = object.hasLegacyScore ?? false;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=credit-monitor-testing-service.js.map